exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pagination {\n  display: flex;\n  justify-content: center;\n  list-style: none; }\n  .pagination .active-pagination-item {\n    margin: 5px;\n    border-radius: 100% !important;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #95CC41;\n    cursor: pointer; }\n  .pagination .inactive-pagination-item {\n    margin: 5px;\n    border-radius: 100% !important;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: grey;\n    cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/reusableComponents/Pagination/pagination.scss
// module id = 2512
// module chunks = 0